import { useNavigate } from "react-router-dom";
import { ModalLabels } from "../../assets/labels/labels";
import { Company } from "../../core/models/company.model";
import Cookies from "universal-cookie";
import { HelperConfig } from "../../core/services/helper/helper.service";

interface ModalRegisterContentProps {
  company: Company | undefined,
  onCloseModal?: () => void,
}

const ModalRegisterContent = (props: ModalRegisterContentProps) => {
  const cookies = new Cookies();
  const { company } = props;
  const navigate = useNavigate();

  const handleRegister = () => {
    if (company?.domain && !company.domain.includes("asuaempresa")) {
      cookies.set('kssreturncompany', company.domain, HelperConfig.cookiesLiteConfig);
    }
    navigate(`/registo`, { state: { selectedCompany: company?.domain }});
  }

  // eslint-disable-next-line 
  const handleLogin = () => {
    if (company?.domain && !company.domain.includes("asuaempresa")) {
      cookies.set('kssreturncompany', company.domain, HelperConfig.cookiesLiteConfig);
    }
    navigate(`/login`, { state: { selectedCompany: company?.domain }});
  }

  return (
    <div className="modal-register-section w-100 d-flex justify-content-center flex-column">
      <div className="modal-register-title container">
        <h2 className="text-center">
          {ModalLabels.modalRegisterTitle(company?.name)}
        </h2>
      </div>
      {/*<div className="modal-register-message mt-2">
        <p className="text-center">{ModalLabels.modalRegisterMessage}</p>
      </div>*/}
      <div className="cta-buttons-container mt-5 d-flex flex-column flex-sm-row d-sm-inline-flex justify-content-center">
        <button
          className="cta-button-primary w-100 w-md-auto d-sm-none"
          onClick={handleRegister}
        >
          {ModalLabels.modalRegisterButton}
        </button>
        {/*<button
          className="cta-button-secondary me-sm-2 w-100 w-md-auto mt-4 mt-sm-0"
          onClick={handleLogin}
        >
          {ModalLabels.modalLoginButton}
        </button>*/}
        <button
          className="cta-button-primary w-100 d-none d-sm-block"
          onClick={handleRegister}
        >
          {ModalLabels.modalRegisterButton}
        </button>
      </div>
    </div>
  );
}

export default ModalRegisterContent;